[
  { "code": "02", "label": "GTIN of contained trade items" },
  { "code": "11", "label": "Production date (YYMMDD)" },
  { "code": "12", "label": "Due date (YYMMDD)" },
  { "code": "13", "label": "Packaging date (YYMMDD)" },
  { "code": "15", "label": "Best before date (YYMMDD)" },
  { "code": "16", "label": "Sell by date (YYMMDD)" },
  { "code": "17", "label": "Expiration date (YYMMDD)" },
  { "code": "20", "label": "Internal product variant" },
  { "code": "240", "label": "Additional product identification assigned by the manufacturer" },
  { "code": "241", "label": "Customer part number" },
  { "code": "242", "label": "Made-to-Order variation number" },
  { "code": "243", "label": "Packaging component number" },
  { "code": "250", "label": "Secondary serial number" },
  { "code": "251", "label": "Reference to source entity" },
  { "code": "30", "label": "Variable count of items (variable measure trade item)" },
  { "code": "3100", "label": "Net weight, kilograms (variable measure trade item)" },
  { "code": "3101", "label": "Net weight, kilograms (variable measure trade item)" },
  { "code": "3102", "label": "Net weight, kilograms (variable measure trade item)" },
  { "code": "3103", "label": "Net weight, kilograms (variable measure trade item)" },
  { "code": "3104", "label": "Net weight, kilograms (variable measure trade item)" },
  { "code": "3105", "label": "Net weight, kilograms (variable measure trade item)" },
  { "code": "3110", "label": "Length or first dimension, metres (variable measure trade item)" },
  { "code": "3111", "label": "Length or first dimension, metres (variable measure trade item)" },
  { "code": "3112", "label": "Length or first dimension, metres (variable measure trade item)" },
  { "code": "3113", "label": "Length or first dimension, metres (variable measure trade item)" },
  { "code": "3114", "label": "Length or first dimension, metres (variable measure trade item)" },
  { "code": "3115", "label": "Length or first dimension, metres (variable measure trade item)" },
  { "code": "3120", "label": "Width, diameter, or second dimension, metres (variable measure trade item)" },
  { "code": "3121", "label": "Width, diameter, or second dimension, metres (variable measure trade item)" },
  { "code": "3122", "label": "Width, diameter, or second dimension, metres (variable measure trade item)" },
  { "code": "3123", "label": "Width, diameter, or second dimension, metres (variable measure trade item)" },
  { "code": "3124", "label": "Width, diameter, or second dimension, metres (variable measure trade item)" },
  { "code": "3125", "label": "Width, diameter, or second dimension, metres (variable measure trade item)" },
  { "code": "3130", "label": "Depth, thickness, height, or third dimension, metres (variable measure trade item)" },
  { "code": "3131", "label": "Depth, thickness, height, or third dimension, metres (variable measure trade item)" },
  { "code": "3132", "label": "Depth, thickness, height, or third dimension, metres (variable measure trade item)" },
  { "code": "3133", "label": "Depth, thickness, height, or third dimension, metres (variable measure trade item)" },
  { "code": "3134", "label": "Depth, thickness, height, or third dimension, metres (variable measure trade item)" },
  { "code": "3135", "label": "Depth, thickness, height, or third dimension, metres (variable measure trade item)" },
  { "code": "3140", "label": "Area, square metres (variable measure trade item)" },
  { "code": "3141", "label": "Area, square metres (variable measure trade item)" },
  { "code": "3142", "label": "Area, square metres (variable measure trade item)" },
  { "code": "3143", "label": "Area, square metres (variable measure trade item)" },
  { "code": "3144", "label": "Area, square metres (variable measure trade item)" },
  { "code": "3145", "label": "Area, square metres (variable measure trade item)" },
  { "code": "3150", "label": "Net volume, litres (variable measure trade item)" },
  { "code": "3151", "label": "Net volume, litres (variable measure trade item)" },
  { "code": "3152", "label": "Net volume, litres (variable measure trade item)" },
  { "code": "3153", "label": "Net volume, litres (variable measure trade item)" },
  { "code": "3154", "label": "Net volume, litres (variable measure trade item)" },
  { "code": "3155", "label": "Net volume, litres (variable measure trade item)" },
  { "code": "3160", "label": "Net volume, cubic metres (variable measure trade item)" },
  { "code": "3161", "label": "Net volume, cubic metres (variable measure trade item)" },
  { "code": "3162", "label": "Net volume, cubic metres (variable measure trade item)" },
  { "code": "3163", "label": "Net volume, cubic metres (variable measure trade item)" },
  { "code": "3164", "label": "Net volume, cubic metres (variable measure trade item)" },
  { "code": "3165", "label": "Net volume, cubic metres (variable measure trade item)" },
  { "code": "3200", "label": "Net weight, pounds (variable measure trade item)" },
  { "code": "3201", "label": "Net weight, pounds (variable measure trade item)" },
  { "code": "3202", "label": "Net weight, pounds (variable measure trade item)" },
  { "code": "3203", "label": "Net weight, pounds (variable measure trade item)" },
  { "code": "3204", "label": "Net weight, pounds (variable measure trade item)" },
  { "code": "3205", "label": "Net weight, pounds (variable measure trade item)" },
  { "code": "3210", "label": "Length or first dimension, inches (variable measure trade item)" },
  { "code": "3211", "label": "Length or first dimension, inches (variable measure trade item)" },
  { "code": "3212", "label": "Length or first dimension, inches (variable measure trade item)" },
  { "code": "3213", "label": "Length or first dimension, inches (variable measure trade item)" },
  { "code": "3214", "label": "Length or first dimension, inches (variable measure trade item)" },
  { "code": "3215", "label": "Length or first dimension, inches (variable measure trade item)" },
  { "code": "3220", "label": "Length or first dimension, feet (variable measure trade item)" },
  { "code": "3221", "label": "Length or first dimension, feet (variable measure trade item)" },
  { "code": "3222", "label": "Length or first dimension, feet (variable measure trade item)" },
  { "code": "3223", "label": "Length or first dimension, feet (variable measure trade item)" },
  { "code": "3224", "label": "Length or first dimension, feet (variable measure trade item)" },
  { "code": "3225", "label": "Length or first dimension, feet (variable measure trade item)" },
  { "code": "3230", "label": "Length or first dimension, yards (variable measure trade item)" },
  { "code": "3231", "label": "Length or first dimension, yards (variable measure trade item)" },
  { "code": "3232", "label": "Length or first dimension, yards (variable measure trade item)" },
  { "code": "3233", "label": "Length or first dimension, yards (variable measure trade item)" },
  { "code": "3234", "label": "Length or first dimension, yards (variable measure trade item)" },
  { "code": "3235", "label": "Length or first dimension, yards (variable measure trade item)" },
  { "code": "3240", "label": "Width, diameter, or second dimension, inches (variable measure trade item)" },
  { "code": "3241", "label": "Width, diameter, or second dimension, inches (variable measure trade item)" },
  { "code": "3242", "label": "Width, diameter, or second dimension, inches (variable measure trade item)" },
  { "code": "3243", "label": "Width, diameter, or second dimension, inches (variable measure trade item)" },
  { "code": "3244", "label": "Width, diameter, or second dimension, inches (variable measure trade item)" },
  { "code": "3245", "label": "Width, diameter, or second dimension, inches (variable measure trade item)" },
  { "code": "3250", "label": "Width, diameter, or second dimension, feet (variable measure trade item)" },
  { "code": "3251", "label": "Width, diameter, or second dimension, feet (variable measure trade item)" },
  { "code": "3252", "label": "Width, diameter, or second dimension, feet (variable measure trade item)" },
  { "code": "3253", "label": "Width, diameter, or second dimension, feet (variable measure trade item)" },
  { "code": "3254", "label": "Width, diameter, or second dimension, feet (variable measure trade item)" },
  { "code": "3255", "label": "Width, diameter, or second dimension, feet (variable measure trade item)" },
  { "code": "3260", "label": "Width, diameter, or second dimension, yards (variable measure trade item)" },
  { "code": "3261", "label": "Width, diameter, or second dimension, yards (variable measure trade item)" },
  { "code": "3262", "label": "Width, diameter, or second dimension, yards (variable measure trade item)" },
  { "code": "3263", "label": "Width, diameter, or second dimension, yards (variable measure trade item)" },
  { "code": "3264", "label": "Width, diameter, or second dimension, yards (variable measure trade item)" },
  { "code": "3265", "label": "Width, diameter, or second dimension, yards (variable measure trade item)" },
  { "code": "3270", "label": "Depth, thickness, height, or third dimension, inches (variable measure trade item)" },
  { "code": "3271", "label": "Depth, thickness, height, or third dimension, inches (variable measure trade item)" },
  { "code": "3272", "label": "Depth, thickness, height, or third dimension, inches (variable measure trade item)" },
  { "code": "3273", "label": "Depth, thickness, height, or third dimension, inches (variable measure trade item)" },
  { "code": "3274", "label": "Depth, thickness, height, or third dimension, inches (variable measure trade item)" },
  { "code": "3275", "label": "Depth, thickness, height, or third dimension, inches (variable measure trade item)" },
  { "code": "3280", "label": "Depth, thickness, height, or third dimension, feet (variable measure trade item)" },
  { "code": "3281", "label": "Depth, thickness, height, or third dimension, feet (variable measure trade item)" },
  { "code": "3282", "label": "Depth, thickness, height, or third dimension, feet (variable measure trade item)" },
  { "code": "3283", "label": "Depth, thickness, height, or third dimension, feet (variable measure trade item)" },
  { "code": "3284", "label": "Depth, thickness, height, or third dimension, feet (variable measure trade item)" },
  { "code": "3285", "label": "Depth, thickness, height, or third dimension, feet (variable measure trade item)" },
  { "code": "3290", "label": "Depth, thickness, height, or third dimension, yards (variable measure trade item)" },
  { "code": "3291", "label": "Depth, thickness, height, or third dimension, yards (variable measure trade item)" },
  { "code": "3292", "label": "Depth, thickness, height, or third dimension, yards (variable measure trade item)" },
  { "code": "3293", "label": "Depth, thickness, height, or third dimension, yards (variable measure trade item)" },
  { "code": "3294", "label": "Depth, thickness, height, or third dimension, yards (variable measure trade item)" },
  { "code": "3295", "label": "Depth, thickness, height, or third dimension, yards (variable measure trade item)" },
  { "code": "3300", "label": "Logistic weight, kilograms" },
  { "code": "3301", "label": "Logistic weight, kilograms" },
  { "code": "3302", "label": "Logistic weight, kilograms" },
  { "code": "3303", "label": "Logistic weight, kilograms" },
  { "code": "3304", "label": "Logistic weight, kilograms" },
  { "code": "3305", "label": "Logistic weight, kilograms" },
  { "code": "3310", "label": "Length or first dimension, metres" },
  { "code": "3311", "label": "Length or first dimension, metres" },
  { "code": "3312", "label": "Length or first dimension, metres" },
  { "code": "3313", "label": "Length or first dimension, metres" },
  { "code": "3314", "label": "Length or first dimension, metres" },
  { "code": "3315", "label": "Length or first dimension, metres" },
  { "code": "3320", "label": "Width, diameter, or second dimension, metres" },
  { "code": "3321", "label": "Width, diameter, or second dimension, metres" },
  { "code": "3322", "label": "Width, diameter, or second dimension, metres" },
  { "code": "3323", "label": "Width, diameter, or second dimension, metres" },
  { "code": "3324", "label": "Width, diameter, or second dimension, metres" },
  { "code": "3325", "label": "Width, diameter, or second dimension, metres" },
  { "code": "3330", "label": "Depth, thickness, height, or third dimension, metres" },
  { "code": "3331", "label": "Depth, thickness, height, or third dimension, metres" },
  { "code": "3332", "label": "Depth, thickness, height, or third dimension, metres" },
  { "code": "3333", "label": "Depth, thickness, height, or third dimension, metres" },
  { "code": "3334", "label": "Depth, thickness, height, or third dimension, metres" },
  { "code": "3335", "label": "Depth, thickness, height, or third dimension, metres" },
  { "code": "3340", "label": "Area, square metres" },
  { "code": "3341", "label": "Area, square metres" },
  { "code": "3342", "label": "Area, square metres" },
  { "code": "3343", "label": "Area, square metres" },
  { "code": "3344", "label": "Area, square metres" },
  { "code": "3345", "label": "Area, square metres" },
  { "code": "3350", "label": "Logistic volume, litres" },
  { "code": "3351", "label": "Logistic volume, litres" },
  { "code": "3352", "label": "Logistic volume, litres" },
  { "code": "3353", "label": "Logistic volume, litres" },
  { "code": "3354", "label": "Logistic volume, litres" },
  { "code": "3355", "label": "Logistic volume, litres" },
  { "code": "3360", "label": "Logistic volume, cubic metres" },
  { "code": "3361", "label": "Logistic volume, cubic metres" },
  { "code": "3362", "label": "Logistic volume, cubic metres" },
  { "code": "3363", "label": "Logistic volume, cubic metres" },
  { "code": "3364", "label": "Logistic volume, cubic metres" },
  { "code": "3365", "label": "Logistic volume, cubic metres" },
  { "code": "3370", "label": "Kilograms per square metre" },
  { "code": "3371", "label": "Kilograms per square metre" },
  { "code": "3372", "label": "Kilograms per square metre" },
  { "code": "3373", "label": "Kilograms per square metre" },
  { "code": "3374", "label": "Kilograms per square metre" },
  { "code": "3375", "label": "Kilograms per square metre" },
  { "code": "3400", "label": "Logistic weight, pounds" },
  { "code": "3401", "label": "Logistic weight, pounds" },
  { "code": "3402", "label": "Logistic weight, pounds" },
  { "code": "3403", "label": "Logistic weight, pounds" },
  { "code": "3404", "label": "Logistic weight, pounds" },
  { "code": "3405", "label": "Logistic weight, pounds" },
  { "code": "3410", "label": "Length or first dimension, inches" },
  { "code": "3411", "label": "Length or first dimension, inches" },
  { "code": "3412", "label": "Length or first dimension, inches" },
  { "code": "3413", "label": "Length or first dimension, inches" },
  { "code": "3414", "label": "Length or first dimension, inches" },
  { "code": "3415", "label": "Length or first dimension, inches" },
  { "code": "3420", "label": "Length or first dimension, feet" },
  { "code": "3421", "label": "Length or first dimension, feet" },
  { "code": "3422", "label": "Length or first dimension, feet" },
  { "code": "3423", "label": "Length or first dimension, feet" },
  { "code": "3424", "label": "Length or first dimension, feet" },
  { "code": "3425", "label": "Length or first dimension, feet" },
  { "code": "3430", "label": "Length or first dimension, yards" },
  { "code": "3431", "label": "Length or first dimension, yards" },
  { "code": "3432", "label": "Length or first dimension, yards" },
  { "code": "3433", "label": "Length or first dimension, yards" },
  { "code": "3434", "label": "Length or first dimension, yards" },
  { "code": "3435", "label": "Length or first dimension, yards" },
  { "code": "3440", "label": "Width, diameter, or second dimension, inches" },
  { "code": "3441", "label": "Width, diameter, or second dimension, inches" },
  { "code": "3442", "label": "Width, diameter, or second dimension, inches" },
  { "code": "3443", "label": "Width, diameter, or second dimension, inches" },
  { "code": "3444", "label": "Width, diameter, or second dimension, inches" },
  { "code": "3445", "label": "Width, diameter, or second dimension, inches" },
  { "code": "3450", "label": "Width, diameter, or second dimension, feet" },
  { "code": "3451", "label": "Width, diameter, or second dimension, feet" },
  { "code": "3452", "label": "Width, diameter, or second dimension, feet" },
  { "code": "3453", "label": "Width, diameter, or second dimension, feet" },
  { "code": "3454", "label": "Width, diameter, or second dimension, feet" },
  { "code": "3455", "label": "Width, diameter, or second dimension, feet" },
  { "code": "3460", "label": "Width, diameter, or second dimension, yard" },
  { "code": "3461", "label": "Width, diameter, or second dimension, yard" },
  { "code": "3462", "label": "Width, diameter, or second dimension, yard" },
  { "code": "3463", "label": "Width, diameter, or second dimension, yard" },
  { "code": "3464", "label": "Width, diameter, or second dimension, yard" },
  { "code": "3465", "label": "Width, diameter, or second dimension, yard" },
  { "code": "3470", "label": "Depth, thickness, height, or third dimension, inches" },
  { "code": "3471", "label": "Depth, thickness, height, or third dimension, inches" },
  { "code": "3472", "label": "Depth, thickness, height, or third dimension, inches" },
  { "code": "3473", "label": "Depth, thickness, height, or third dimension, inches" },
  { "code": "3474", "label": "Depth, thickness, height, or third dimension, inches" },
  { "code": "3475", "label": "Depth, thickness, height, or third dimension, inches" },
  { "code": "3480", "label": "Depth, thickness, height, or third dimension, feet" },
  { "code": "3481", "label": "Depth, thickness, height, or third dimension, feet" },
  { "code": "3482", "label": "Depth, thickness, height, or third dimension, feet" },
  { "code": "3483", "label": "Depth, thickness, height, or third dimension, feet" },
  { "code": "3484", "label": "Depth, thickness, height, or third dimension, feet" },
  { "code": "3485", "label": "Depth, thickness, height, or third dimension, feet" },
  { "code": "3490", "label": "Depth, thickness, height, or third dimension, yards" },
  { "code": "3491", "label": "Depth, thickness, height, or third dimension, yards" },
  { "code": "3492", "label": "Depth, thickness, height, or third dimension, yards" },
  { "code": "3493", "label": "Depth, thickness, height, or third dimension, yards" },
  { "code": "3494", "label": "Depth, thickness, height, or third dimension, yards" },
  { "code": "3495", "label": "Depth, thickness, height, or third dimension, yards" },
  { "code": "3500", "label": "Area, square inches (variable measure trade item)" },
  { "code": "3501", "label": "Area, square inches (variable measure trade item)" },
  { "code": "3502", "label": "Area, square inches (variable measure trade item)" },
  { "code": "3503", "label": "Area, square inches (variable measure trade item)" },
  { "code": "3504", "label": "Area, square inches (variable measure trade item)" },
  { "code": "3505", "label": "Area, square inches (variable measure trade item)" },
  { "code": "3510", "label": "Area, square feet (variable measure trade item)" },
  { "code": "3511", "label": "Area, square feet (variable measure trade item)" },
  { "code": "3512", "label": "Area, square feet (variable measure trade item)" },
  { "code": "3513", "label": "Area, square feet (variable measure trade item)" },
  { "code": "3514", "label": "Area, square feet (variable measure trade item)" },
  { "code": "3515", "label": "Area, square feet (variable measure trade item)" },
  { "code": "3520", "label": "Area, square yards (variable measure trade item)" },
  { "code": "3521", "label": "Area, square yards (variable measure trade item)" },
  { "code": "3522", "label": "Area, square yards (variable measure trade item)" },
  { "code": "3523", "label": "Area, square yards (variable measure trade item)" },
  { "code": "3524", "label": "Area, square yards (variable measure trade item)" },
  { "code": "3525", "label": "Area, square yards (variable measure trade item)" },
  { "code": "3530", "label": "Area, square inches" },
  { "code": "3531", "label": "Area, square inches" },
  { "code": "3532", "label": "Area, square inches" },
  { "code": "3533", "label": "Area, square inches" },
  { "code": "3534", "label": "Area, square inches" },
  { "code": "3535", "label": "Area, square inches" },
  { "code": "3540", "label": "Area, square feet" },
  { "code": "3541", "label": "Area, square feet" },
  { "code": "3542", "label": "Area, square feet" },
  { "code": "3543", "label": "Area, square feet" },
  { "code": "3544", "label": "Area, square feet" },
  { "code": "3545", "label": "Area, square feet" },
  { "code": "3550", "label": "Area, square yards" },
  { "code": "3551", "label": "Area, square yards" },
  { "code": "3552", "label": "Area, square yards" },
  { "code": "3553", "label": "Area, square yards" },
  { "code": "3554", "label": "Area, square yards" },
  { "code": "3555", "label": "Area, square yards" },
  { "code": "3560", "label": "Net weight, troy ounces (variable measure trade item)" },
  { "code": "3561", "label": "Net weight, troy ounces (variable measure trade item)" },
  { "code": "3562", "label": "Net weight, troy ounces (variable measure trade item)" },
  { "code": "3563", "label": "Net weight, troy ounces (variable measure trade item)" },
  { "code": "3564", "label": "Net weight, troy ounces (variable measure trade item)" },
  { "code": "3565", "label": "Net weight, troy ounces (variable measure trade item)" },
  { "code": "3570", "label": "Net weight (or volume), ounces (variable measure trade item)" },
  { "code": "3571", "label": "Net weight (or volume), ounces (variable measure trade item)" },
  { "code": "3572", "label": "Net weight (or volume), ounces (variable measure trade item)" },
  { "code": "3573", "label": "Net weight (or volume), ounces (variable measure trade item)" },
  { "code": "3574", "label": "Net weight (or volume), ounces (variable measure trade item)" },
  { "code": "3575", "label": "Net weight (or volume), ounces (variable measure trade item)" },
  { "code": "3600", "label": "Net volume, quarts (variable measure trade item)" },
  { "code": "3601", "label": "Net volume, quarts (variable measure trade item)" },
  { "code": "3602", "label": "Net volume, quarts (variable measure trade item)" },
  { "code": "3603", "label": "Net volume, quarts (variable measure trade item)" },
  { "code": "3604", "label": "Net volume, quarts (variable measure trade item)" },
  { "code": "3605", "label": "Net volume, quarts (variable measure trade item)" },
  { "code": "3610", "label": "Net volume, gallons U.S. (variable measure trade item)" },
  { "code": "3611", "label": "Net volume, gallons U.S. (variable measure trade item)" },
  { "code": "3612", "label": "Net volume, gallons U.S. (variable measure trade item)" },
  { "code": "3613", "label": "Net volume, gallons U.S. (variable measure trade item)" },
  { "code": "3614", "label": "Net volume, gallons U.S. (variable measure trade item)" },
  { "code": "3615", "label": "Net volume, gallons U.S. (variable measure trade item)" },
  { "code": "3620", "label": "Logistic volume, quarts" },
  { "code": "3621", "label": "Logistic volume, quarts" },
  { "code": "3622", "label": "Logistic volume, quarts" },
  { "code": "3623", "label": "Logistic volume, quarts" },
  { "code": "3624", "label": "Logistic volume, quarts" },
  { "code": "3625", "label": "Logistic volume, quarts" },
  { "code": "3630", "label": "Logistic volume, gallons U.S." },
  { "code": "3631", "label": "Logistic volume, gallons U.S." },
  { "code": "3632", "label": "Logistic volume, gallons U.S." },
  { "code": "3633", "label": "Logistic volume, gallons U.S." },
  { "code": "3634", "label": "Logistic volume, gallons U.S." },
  { "code": "3635", "label": "Logistic volume, gallons U.S." },
  { "code": "3640", "label": "Net volume, cubic inches (variable measure trade item)" },
  { "code": "3641", "label": "Net volume, cubic inches (variable measure trade item)" },
  { "code": "3642", "label": "Net volume, cubic inches (variable measure trade item)" },
  { "code": "3643", "label": "Net volume, cubic inches (variable measure trade item)" },
  { "code": "3644", "label": "Net volume, cubic inches (variable measure trade item)" },
  { "code": "3645", "label": "Net volume, cubic inches (variable measure trade item)" },
  { "code": "3650", "label": "Net volume, cubic feet (variable measure trade item)" },
  { "code": "3651", "label": "Net volume, cubic feet (variable measure trade item)" },
  { "code": "3652", "label": "Net volume, cubic feet (variable measure trade item)" },
  { "code": "3653", "label": "Net volume, cubic feet (variable measure trade item)" },
  { "code": "3654", "label": "Net volume, cubic feet (variable measure trade item)" },
  { "code": "3655", "label": "Net volume, cubic feet (variable measure trade item)" },
  { "code": "3660", "label": "Net volume, cubic yards (variable measure trade item)" },
  { "code": "3661", "label": "Net volume, cubic yards (variable measure trade item)" },
  { "code": "3662", "label": "Net volume, cubic yards (variable measure trade item)" },
  { "code": "3663", "label": "Net volume, cubic yards (variable measure trade item)" },
  { "code": "3664", "label": "Net volume, cubic yards (variable measure trade item)" },
  { "code": "3665", "label": "Net volume, cubic yards (variable measure trade item)" },
  { "code": "3670", "label": "Logistic volume, cubic inches" },
  { "code": "3671", "label": "Logistic volume, cubic inches" },
  { "code": "3672", "label": "Logistic volume, cubic inches" },
  { "code": "3673", "label": "Logistic volume, cubic inches" },
  { "code": "3674", "label": "Logistic volume, cubic inches" },
  { "code": "3675", "label": "Logistic volume, cubic inches" },
  { "code": "3680", "label": "Logistic volume, cubic feet" },
  { "code": "3681", "label": "Logistic volume, cubic feet" },
  { "code": "3682", "label": "Logistic volume, cubic feet" },
  { "code": "3683", "label": "Logistic volume, cubic feet" },
  { "code": "3684", "label": "Logistic volume, cubic feet" },
  { "code": "3685", "label": "Logistic volume, cubic feet" },
  { "code": "3690", "label": "Logistic volume, cubic yards" },
  { "code": "3691", "label": "Logistic volume, cubic yards" },
  { "code": "3692", "label": "Logistic volume, cubic yards" },
  { "code": "3693", "label": "Logistic volume, cubic yards" },
  { "code": "3694", "label": "Logistic volume, cubic yards" },
  { "code": "3695", "label": "Logistic volume, cubic yards" },
  { "code": "37", "label": "Count of trade items or trade item pieces contained in a logistic unit" },
  { "code": "3900", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3901", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3902", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3903", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3904", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3905", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3906", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3907", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3908", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3909", "label": "Applicable amount payable or Coupon value, local currency" },
  { "code": "3910", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3911", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3912", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3913", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3914", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3915", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3916", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3917", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3918", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3919", "label": "Applicable amount payable with ISO currency code" },
  { "code": "3920", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3921", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3922", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3923", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3924", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3925", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3926", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3927", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3928", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3929", "label": "Applicable amount payable, single monetary area (variable measure trade item)" },
  { "code": "3930", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3931", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3932", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3933", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3934", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3935", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3936", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3937", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3938", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3939", "label": "Applicable amount payable with ISO currency code (variable measure trade item)" },
  { "code": "3940", "label": "Percentage discount of a coupon" },
  { "code": "3941", "label": "Percentage discount of a coupon" },
  { "code": "3942", "label": "Percentage discount of a coupon" },
  { "code": "3943", "label": "Percentage discount of a coupon" },
  { "code": "3950", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3951", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3952", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3953", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3954", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3955", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3956", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3957", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3958", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "3959", "label": "Amount Payable per unit of measure single monetary area (variable measure trade item)" },
  { "code": "400", "label": "Customers purchase order number" },
  { "code": "403", "label": "Routing code" },
  { "code": "410", "label": "Ship to / Deliver to Global Location Number" },
  { "code": "411", "label": "Bill to / Invoice to Global Location Number" },
  { "code": "412", "label": "Purchased from Global Location Number" },
  { "code": "413", "label": "Ship for / Deliver for - Forward to Global Location Number" },
  { "code": "415", "label": "Global Location Number of the invoicing party" },
  { "code": "416", "label": "GLN of the production or service location" },
  { "code": "420", "label": "Ship to / Deliver to postal code within a single postal authority" },
  { "code": "421", "label": "Ship to / Deliver to postal code with ISO country code" },
  { "code": "422", "label": "Country of origin of a trade item" },
  { "code": "423", "label": "Country of initial processing" },
  { "code": "424", "label": "Country of processing" },
  { "code": "425", "label": "Country of disassembly" },
  { "code": "426", "label": "Country covering full process chain" },
  { "code": "427", "label": "Country subdivision Of origin" },
  { "code": "4300", "label": "Ship-to / Deliver-to company name" },
  { "code": "4301", "label": "Ship-to / Deliver-to contact" },
  { "code": "4302", "label": "Ship-to / Deliver-to address line 1" },
  { "code": "4303", "label": "Ship-to / Deliver-to address line 2" },
  { "code": "4304", "label": "Ship-to / Deliver-to suburb" },
  { "code": "4305", "label": "Ship-to / Deliver-to locality" },
  { "code": "4306", "label": "Ship-to / Deliver-to region" },
  { "code": "4307", "label": "Ship-to / Deliver-to country code" },
  { "code": "4308", "label": "Ship-to / Deliver-to telephone number" },
  { "code": "4310", "label": "Return-to company name" },
  { "code": "4311", "label": "Return-to contact" },
  { "code": "4312", "label": "Return-to address line 1" },
  { "code": "4313", "label": "Return-to address line 2" },
  { "code": "4314", "label": "Return-to suburb" },
  { "code": "4315", "label": "Return-to locality" },
  { "code": "4316", "label": "Return-to region" },
  { "code": "4317", "label": "Return-to country code" },
  { "code": "4318", "label": "Return-to postal code" },
  { "code": "4319", "label": "Return-to telephone number" },
  { "code": "4320", "label": "Service code description" },
  { "code": "4321", "label": "Dangerous goods flag" },
  { "code": "4322", "label": "Authority to leave" },
  { "code": "4323", "label": "Signature required flag" },
  { "code": "4324", "label": "Not before delivery date time" },
  { "code": "4325", "label": "Not after delivery date time" },
  { "code": "4326", "label": "Release date" },
  { "code": "7001", "label": "NATO Stock Number (NSN)" },
  { "code": "7002", "label": "UN/ECE meat carcasses and cuts classification" },
  { "code": "7003", "label": "Expiration date and time" },
  { "code": "7004", "label": "Active potency" },
  { "code": "7005", "label": "Catch area" },
  { "code": "7006", "label": "First freeze date" },
  { "code": "7007", "label": "Harvest date" },
  { "code": "7008", "label": "Species for fishery purposes" },
  { "code": "7009", "label": "Fishing gear type" },
  { "code": "7010", "label": "Production method" },
  { "code": "7020", "label": "Refurbishment lot ID" },
  { "code": "7021", "label": "Functional status" },
  { "code": "7022", "label": "Revision status" },
  { "code": "7023", "label": "Global Individual Asset Identifier (GIAI) of an assembly" },
  { "code": "7030", "label": "Number of processor with ISO Country Code" },
  { "code": "7031", "label": "Number of processor with ISO Country Code" },
  { "code": "7032", "label": "Number of processor with ISO Country Code" },
  { "code": "7033", "label": "Number of processor with ISO Country Code" },
  { "code": "7034", "label": "Number of processor with ISO Country Code" },
  { "code": "7035", "label": "Number of processor with ISO Country Code" },
  { "code": "7036", "label": "Number of processor with ISO Country Code" },
  { "code": "7037", "label": "Number of processor with ISO Country Code" },
  { "code": "7038", "label": "Number of processor with ISO Country Code" },
  { "code": "7039", "label": "Number of processor with ISO Country Code" },
  { "code": "7040", "label": "GS1 UIC with Extension 1 and Importer index" },
  { "code": "710", "label": "National Healthcare Reimbursement Number (NHRN) - Germany PZN" },
  { "code": "711", "label": "National Healthcare Reimbursement Number (NHRN) - France CIP" },
  { "code": "712", "label": "National Healthcare Reimbursement Number (NHRN) - Spain CN" },
  { "code": "713", "label": "National Healthcare Reimbursement Number (NHRN) - Brasil DRN" },
  { "code": "714", "label": "National Healthcare Reimbursement Number (NHRN) - Portugal AIM" },
  { "code": "7230", "label": "Certification reference" },
  { "code": "7231", "label": "Certification reference" },
  { "code": "7232", "label": "Certification reference" },
  { "code": "7233", "label": "Certification reference" },
  { "code": "7234", "label": "Certification reference" },
  { "code": "7235", "label": "Certification reference" },
  { "code": "7236", "label": "Certification reference" },
  { "code": "7237", "label": "Certification reference" },
  { "code": "7238", "label": "Certification reference" },
  { "code": "7239", "label": "Certification reference" },
  { "code": "8001", "label": "Roll products (width, length, core diameter, direction, splices)" },
  { "code": "8002", "label": "Cellular mobile telephone identifier" },
  { "code": "8005", "label": "Price per unit of measure" },
  { "code": "8007", "label": "International Bank Account Number (IBAN)" },
  { "code": "8008", "label": "Date and time of production" },
  { "code": "8009", "label": "Optically Readable Sensor Indicator" },
  { "code": "8012", "label": "Software version" },
  { "code": "8026", "label": "Identification of pieces of a trade item (ITIP) contained in a logistic unit" },
  { "code": "8110", "label": "Coupon code identification for use in North America" },
  { "code": "8111", "label": "Loyalty points of a coupon" },
  { "code": "8112", "label": "Paperless coupon code identification for use in North America" },
  { "code": "8200", "label": "Extended Packaging URL" },
  { "code": "90", "label": "Information mutually agreed between trading partners" },
  { "code": "91", "label": "Company internal information" },
  { "code": "92", "label": "Company internal information" },
  { "code": "93", "label": "Company internal information" },
  { "code": "94", "label": "Company internal information" },
  { "code": "95", "label": "Company internal information" },
  { "code": "96", "label": "Company internal information" },
  { "code": "97", "label": "Company internal information" },
  { "code": "98", "label": "Company internal information" },
  { "code": "99", "label": "Company internal information" }
]
